import { ICellRendererParams } from '@ag-grid-community/core'
import { Button } from 'components/common'
import Modal from 'components/modal'
import toast from 'react-hot-toast'
import { deleteFtpProfile } from 'utils/api/ftpProfileApi'

type Props = {
  isOpen: boolean
  closeModal: () => void
  params?: ICellRendererParams
}

const ConfirmDeleteFtpProfileModal = ({
  params,
  closeModal,
  isOpen,
}: Props) => {
  // close the modal and untick the delete ftp profile checkbox
  const cancelDeleteFtpProfile = () => {
    if (params?.data?._id) {
      const rowNode = params.api.getRowNode(params.data._id)
      rowNode?.setSelected(false)
    }
    closeModal()
  }

  // delete the ftp profile and remove from table
  const handleDeleteFtpProfile = async () => {
    if (params?.data?._id) {
      const deleteToast = toast.loading('Deleting FTP Profile...', {
        duration: Infinity,
      })
      try {
        // deleting ftp profile api
        await deleteFtpProfile(params.data._id)

        // remove row from table
        const rowNode = params.api.getRowNode(params.data._id)
        params.api.applyTransaction({ remove: [rowNode?.data] })

        toast.success('FTP profile deleted successfully!', {
          duration: 3000,
          id: deleteToast,
        })

        // closing modal
        closeModal()
      } catch (error) {
        toast.error('Failed to delete FTP profile.', {
          duration: 3000,
          id: deleteToast,
        })
      }
    }
  }

  return (
    <Modal
      width={550}
      title={`Confirm delete "${params?.data?.name}" ?`}
      titleClassname="text-xl font-semibold max-w-xl"
      isOpen={isOpen}
      closeModal={cancelDeleteFtpProfile}
      customStyle={{
        padding: '25px 40px',
      }}
    >
      <>
        <div>
          Deleting <strong>{params?.data?.name}</strong> will remove this FTP
          profile. Any aggregator store group currently pointing to it will fall
          back to that aggregator&apos;s default FTP configuration. Are you sure
          you want to proceed with the deletion?
        </div>

        {/* Actions */}
        <div className="mt-6 flex  w-full items-center gap-5">
          <Button
            onClick={handleDeleteFtpProfile}
            className="w-full"
            buttonText="Confirm"
            type="button"
          />
          <Button
            className="w-full"
            buttonText="Cancel"
            variant="outline"
            type="button"
            onClick={cancelDeleteFtpProfile}
          />
        </div>
      </>
    </Modal>
  )
}

export default ConfirmDeleteFtpProfileModal
